import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import ActionsDropdown from "../ActionsDropdown";
import Select from "react-select";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(even) {
    background-color: #ffffff; /* Light gray for even rows */
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #ffffff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Funnel() {
  const [responseData, setResponseData] = useState([]);
  const [showCallbackDate, setShowCallbackDate] = useState(false);
  const [Updateshow, setUpdateShow] = useState(false);

  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});

  const navigate = useNavigate();
  const updateinfo = (_id) => {
    navigate(`/Leadhistroy/${_id}`);
  };

  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      branch_id: {
        _id: item.branch_id?._id ?? null,
        branch_name: item.branch_id?.branch_name ?? "",
      },
      student_name: item.student_name,
      mobile_no: item.mobile_no,
      email: item.email,
      Prefered_course: item.Prefered_course,
      course_id: item.course_id,
      Enquiry_date: item.Enquiry_date,
      Source_type: item.Source_type,
      contact_type: item.contact_type,
      assign_staff: item.assign_staff,
      referal_candidate_name: item.referal_candidate_name,
      referal_candidate: item.referal_candidate,
      followups_time: item.followups_time,
      followups_date: item.followups_date,
      status_date: item.status_date,
      status_time: item.status_time,
      followups_status: item.followups_status,
      followups_notes: item.followups_notes,
      interest: item.interest,
      qualification: item.qualification,
    }));
  }, [responseData]);

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => {
          return row.index + 1;
        },
      },
      {
        Header: "Name",
        accessor: "student_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Mobile",
        accessor: "mobile_no",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Course",
        accessor: "Prefered_course",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Source",
        accessor: "Source_type",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Notes",
        accessor: "followups_notes",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Interest",
        accessor: "interest",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      // {
      //   Header: "Status",
      //   accessor: "followups_status",
      //   Filter: DefaultColumnFilter,
      //   filter: "multiSelectFilter",
      // },
      {
        Header: "Status",
        accessor: "followups_status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        width: 120,
        height: 10,
        Cell: ({ value }) => {
          const statusClass = getStatusLabelClass(value); // Get the class for the status

          return (
            <span
              className={`${statusClass}`} // Apply the class dynamically based on the status
              style={{
                display: "inline-block",
                width: "120px", // Set fixed width for the content
                height: "20px", // Set fixed height for the content
                lineHeight: "15px", // Vertically center text inside the span
                textAlign: "center", // Center align text horizontally
              }}
            >
              {value}
            </span>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  useEffect(() => {
    fetchData();
    gettoken();
    getprevillages();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // async function fetchData() {
  //   try {
  //     setLoading(true);
  //     const resposponseData = await axios.get(apiUrl + "/funnel", {
  //       params: { data: localStorage.getItem("branch_id") },
  //     });

  //     // Check if the response data is an array
  //     if (Array.isArray(resposponseData.data)) {
  //       console.log("the funnel console", resposponseData.data);
  //       setResponseData(resposponseData.data.reverse());
  //     } else {
  //       console.error("Expected an array but received:", resposponseData.data);
  //       setResponseData([]); // or handle this error as needed
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 1000);
  // }

  async function fetchData() {
    try {
      setLoading(true);
      const responseData = await axios.get(apiUrl + "/funnel", {
        params: { data: localStorage.getItem("branch_id") },
      });

      const username = localStorage.getItem("username");
      const branch_name = localStorage.getItem("branch_name");
      console.log("Branch name:", branch_name);
      console.log("Username:", username);

      if (branch_name === "Branches") {
        if (responseData && responseData.data) {
          const data = responseData.data;
          // const filteredData = data.filter((item) => item.interest !== "Interest");
          // console.log("Filtered Data for Branches:", filteredData);
          setResponseData(data);
        }
      } else {
        const internal_emp = localStorage.getItem("internal_emp");
        console.log(
          "Response from server for non-branches:",
          responseData.data
        );
        const filteredData = responseData.data.filter(
          (item) =>
            item.assign_staff?.empid === username ||
            item.assign_staff?.empid === internal_emp
        );
        setResponseData(filteredData);
      }

      // Check if the response data is an array
      if (Array.isArray(responseData.data)) {
        console.log("Funnel data received:", responseData.data);
        setResponseData(responseData.data.reverse());
      } else {
        console.error("Expected an array but received:", responseData.data);
        setResponseData([]); // Handle error gracefully
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setResponseData([]); // Optionally reset data on error
    } finally {
      // Ensure loading state is updated even if there's an error
      setLoading(false);
    }
  }

  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });

      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      // getpages();

      if (id) {
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find((item) => item.name == "Funnel");

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions);
  };

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const filtered = currentItems.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(responseData.length / itemsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === totalPages ? prevPage : prevPage + 1
    );
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
  };
  // ============================================================================

  // const createPagination = () => {
  //   let liTag = [];
  //   let beforePage = currentPage - 1;
  //   let afterPage = currentPage + 1;
  //   let active;

  //   if (currentPage > 1) {
  //     liTag.push(
  //       <li className="page-item" key="prev">
  //         <button
  //           className="page-link"
  //           onClick={() => paginate(currentPage - 1)}
  //         >
  //           <FaAngleLeft /> Prev
  //         </button>
  //       </li>
  //     );
  //   }

  //   if (currentPage > 2) {
  //     liTag.push(
  //       <li className="page-item" key="first" onClick={() => paginate(1)}>
  //         <button className="page-link">1</button>
  //       </li>
  //     );
  //     if (currentPage > 3) {
  //       liTag.push(
  //         <li className="page-item disabled" key="dots1">
  //           <span className="page-link">...</span>
  //         </li>
  //       );
  //     }
  //   }

  //   if (currentPage === totalPages) {
  //     beforePage -= 2;
  //   } else if (currentPage === totalPages - 1) {
  //     beforePage -= 1;
  //   }

  //   if (currentPage === 1) {
  //     afterPage += 2;
  //   } else if (currentPage === 2) {
  //     afterPage += 1;
  //   }

  //   for (let plength = beforePage; plength <= afterPage; plength++) {
  //     if (plength > totalPages || plength <= 0) continue;
  //     active = currentPage === plength ? "active" : "";
  //     liTag.push(
  //       <li
  //         className={`page-item ${active}`}
  //         key={plength}
  //         onClick={() => paginate(plength)}
  //       >
  //         <button className="page-link">{plength}</button>
  //       </li>
  //     );
  //   }

  //   if (currentPage < totalPages - 1) {
  //     if (currentPage < totalPages - 2) {
  //       liTag.push(
  //         <li className="page-item disabled" key="dots2">
  //           <span className="page-link">...</span>
  //         </li>
  //       );
  //     }
  //     liTag.push(
  //       <li
  //         className="page-item"
  //         key="last"
  //         onClick={() => paginate(totalPages)}
  //       >
  //         <button className="page-link">{totalPages}</button>
  //       </li>
  //     );
  //   }

  //   if (currentPage < totalPages) {
  //     liTag.push(
  //       <li className="page-item" key="next">
  //         <button
  //           className="page-link"
  //           onClick={() => paginate(currentPage + 1)}
  //         >
  //           Next <FaAngleRight />
  //         </button>
  //       </li>
  //     );
  //   }

  //   return liTag;
  // };

  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li
        className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
        key="prev"
      >
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 0 ? "active" : ""}`}
          key={0}
        >
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
          key={1}
        >
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 3, currentPage + 1);
      i++
    ) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 2 ? "active" : ""
            }`}
          key={totalPages - 2}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 2)}
          >
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 1 ? "active" : ""
            }`}
          key={totalPages - 1}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 1)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  const [startTime, setStartTime] = useState(null); // To store the start time
  const [endTime, setEndTime] = useState(null);
  const [UpdatedData, setUpdatedData] = useState([]);
  const handleUpdated = async (_id, data) => {
    if (previllages.edit || previllages.all) {
      console.log("this", _id);
      const filterUpdateData = await axios.get(apiUrl + `/leads/${_id}`);
      console.log(filterUpdateData.data?.[0], "filterUpdateD99");
      setUpdatedData(filterUpdateData.data?.[0]);
      const currentTime = new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      // Set the formatted time to state
      setStartTime(currentTime);
      setUpdateShow(true);
    } else {
      toast.error("You don't have the permission to update");
    }
  };

  const handleupdatesubmit = async (id) => {
    const endTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    setEndTime(endTime);

    // Convert 12-hour time (e.g., "11:32 AM") to 24-hour format (e.g., "11:32")
    const convertTo24Hour = (time) => {
      const [timeString, period] = time.split(" ");
      let [hours, minutes] = timeString.split(":").map((num) => parseInt(num));

      if (period === "PM" && hours !== 12) {
        hours += 12; // Convert PM times to 24-hour format, except for 12 PM which stays the same
      }
      if (period === "AM" && hours === 12) {
        hours = 0; // 12 AM should be 00 in 24-hour format
      }

      // Format to "HH:mm"
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
    };

    // Convert startTime and endTime to 24-hour format
    const startTime24 = convertTo24Hour(startTime);
    const endTime24 = convertTo24Hour(endTime);

    console.log("this is my start time", startTime24);
    console.log("this is my endTime time", endTime24);

    // Create date objects using 24-hour time format
    const startDate = new Date(`1970-01-01T${startTime24}:00`);
    const endDate = new Date(`1970-01-01T${endTime24}:00`);

    // Check if dates are valid
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error("Invalid date format");
      return;
    }

    // Handle time difference calculation when endTime is earlier than startTime (i.e., crossing midnight)
    let timeDifference = endDate - startDate;
    if (timeDifference < 0) {
      // If the difference is negative, it means endTime is on the next day
      endDate.setDate(endDate.getDate() + 1);
      timeDifference = endDate - startDate;
    }

    // Convert the time difference from milliseconds to minutes
    const timeDifferenceInMinutes = Math.floor(timeDifference / 1000 / 60);

    console.log(`Time Difference: ${timeDifferenceInMinutes} minutes`);

    try {
      console.log(id, "idddss");
      const updateDatas = {
        branch_id: UpdatedData.branch_id,
        student_name: UpdatedData.student_name,
        mobile_no: UpdatedData.mobile_no,
        email: UpdatedData.email,
        Source_type: UpdatedData.Source_type,
        referal_candidate: UpdatedData.referal_candidate || "",
        referal_candidate_name: UpdatedData.referal_candidate_name || "",
        Enquiry_date: UpdatedData.Enquiry_date,
        interest: "Interest",
        Prefered_course: UpdatedData.Prefered_course,
        followups_date: UpdatedData.status_date,
        status_time: UpdatedData.status_time,
        followups_status: UpdatedData.followups_status,
        followups_notes: UpdatedData.followups_notes,
        assign_staff: UpdatedData.assign_staff,
        duration_time: timeDifferenceInMinutes,
      };
      try {
        setLoading(true);
        console.log("The console update  data as is : ", updateDatas, id);
        const response = await axios.put(apiUrl + `/leads/${id}`, updateDatas);
        console.log("the response : ", response);

        const student_Id = response.data._id;
        console.log("the histroy  update post", student_Id);
        const formDataaa = {
          student_Id: student_Id,
          Source_type: "",
          Enquiry_date: "",
          contact_type: UpdatedData.contact_type,
          assign_staff: UpdatedData.assign_staff,
          notes: UpdatedData.followups_notes,
          status: UpdatedData.followups_status,
          duration_time: timeDifferenceInMinutes,
        };

        if (response.status == 200) {
          const response12 = await axios.post(
            apiUrl + "/leadhistroy",
            formDataaa
          );
          console.log("the histroy folloup", response12);
        }

        if (response.status == 200) {
          fetchData();
          toast.success("Converted sucessfully!");
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          setUpdateShow(false);
        } else {
          toast.error("failed to convert !");
        }
      } catch (error) {
        toast.error("error in convert !");
        console.log("Error fetching data:", error.message);
      }
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };
  // Helper function to format ISO date to YYYY-MM-DD
  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const getStatusLabelClass = (status) => {
    switch (status) {
      case "Unqualified":
        return "bg-danger1 text-white1";
      case "Reachable":
        return "bg-secondary1 text-white1";
      case "Converted":
        return "bg-warning1 text-black1"; // Assuming black text for "converted"
      case "Rescheduled":
        return "bg-primary1 text-white1";
      case "Walkin":
        return "bg-success1 text-white1";
      case "NotReachable":
        return "bg-dark1 text-white1";
      case "Scheduled":
        return "bg-info1 text-white1";
      case "New":
        return "bg-dark1 text-white1";
      case "Walk-in-reschedule":
        return "bg-dark1 text-white1";
      case "Phone Ringing":
        return "bg-phone text-white1 ";
      default:
        return "";
    }
  };

  const [rolename, setrolename] = useState([]);
  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const [loading, setLoading] = useState(false);
  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-11">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="#" className="text-secondary dashBoard_text">
                <b>Leads / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Funnel</b>
              </Link>
            </div>
          </div>
        </div>


        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">

              <div>
                <h5 className="mt-2">Funnel</h5>
              </div>

            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

              {/* </div>

            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "All") {
                        setPageSize(data.length); // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) =>
                        handleUpdated(id, row)
                      }
                      onInfo={(id) => {
                        setLoading(true);
                        setTimeout(() => {
                          updateinfo(id);
                          setLoading(false);
                        }, 1000);
                      }}
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        {/* ///////////////////////////////////////////////////////////////////////////////////// */}

        <Modal show={Updateshow} onHide={() => setUpdateShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Funnel Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Other input fields */}
            <div className="row">
              <div className="col-lg-12 ">
                <div className=" p-2 pb-0">
                  <div className="form-group">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            disabled
                            value={UpdatedData.student_name}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                student_name: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={UpdatedData.student_name ? "filled" : ""}
                          >
                            Name
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="tel"
                            placeholder=""
                            value={UpdatedData.mobile_no}
                            disabled
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                mobile_no: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={UpdatedData.mobile_no ? "filled" : ""}
                          >
                            Mobile No
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="tel"
                            placeholder=""
                            value={UpdatedData.Prefered_course}
                            disabled
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                Prefered_course: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={
                              UpdatedData.Prefered_course ? "filled" : ""
                            }
                          >
                            Prefered Course
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="tel"
                            placeholder=""
                            value={UpdatedData.Source_type}
                            disabled
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                Source_type: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={UpdatedData.Source_type ? "filled" : ""}
                          >
                            Source_type
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="floating-label">
                          <select
                            className="form-control"
                            value={UpdatedData.followups_status || ""}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                followups_status: e.target.value,
                              })
                            }
                            required
                          >
                            <option value="">Select Followups Status</option>{" "}
                            {/* Default option */}
                            <option value="Rescheduled">Rescheduled</option>
                            <option value="Walkin">Walkin</option>
                            <option value="Unqualified">Unqualified</option>
                            <option value="Not Reachable">Not Reachable</option>
                            <option value="Phone Ringing">Phone Ringing</option>
                          </select>
                          <label
                            className={
                              UpdatedData.followups_status ? "filled" : ""
                            }
                          >
                            Followups Status
                          </label>
                        </div>
                      </div>

                      <div
                        className={`${UpdatedData.followups_status == "Rescheduled"
                          ? "row"
                          : "d-none"
                          }`}
                      >
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              placeholder=""
                              value={
                                UpdatedData.status_date
                                  ? formatDatefitching(UpdatedData.status_date)
                                  : ""
                              }
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  status_date: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={
                                UpdatedData.status_date ? "filled" : ""
                              }
                            >
                              Reschudule Date
                            </label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="time"
                              placeholder=""
                              value={UpdatedData.status_time}
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  status_time: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={UpdatedData.mobile_no ? "filled" : ""}
                            >
                              Reschudule Time
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`${UpdatedData.followups_status == "Walkin"
                          ? "row"
                          : "d-none"
                          }`}
                      >
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              placeholder=""
                              value={
                                UpdatedData.status_date
                                  ? formatDatefitching(UpdatedData.status_date)
                                  : ""
                              }
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  status_date: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={
                                UpdatedData.status_date ? "filled" : ""
                              }
                            >
                              Visit Date
                            </label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="time"
                              placeholder=""
                              value={UpdatedData.status_time}
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  status_time: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={
                                UpdatedData.status_time ? "filled" : ""
                              }
                            >
                              Visit Time
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          UpdatedData.followups_status === "Walkin" ||
                            UpdatedData.followups_status === "Rescheduled"
                            ? "row"
                            : "d-none"
                        }
                      >
                        <div className="floating-label">
                          <textarea
                            className="form-control"
                            value={UpdatedData.followups_notes || ""}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                followups_notes: e.target.value,
                              })
                            }
                            required
                          ></textarea>
                          <label
                            className={
                              UpdatedData.followups_notes ? "filled" : ""
                            }
                          >
                            Followups Notes
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShow(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={() => handleupdatesubmit(UpdatedData._id)}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {currentPage} of {totalPages}
              </span>
            </div>
            <div className="col-lg-5">
              <nav>
                <ul className="pagination justify-content-center">
                  {createPagination()}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Funnel;
